export const routeName = 'legal-disclaimer';
/**
 * The slugs the archived site served, plus French, which it does not publish and this one does.
 * Deliberately identical where the two sites overlap — the same reasoning as `about-us` and `contact`:
 * a visitor who lands on one host's legal notice and switches to the other should not change URL word.
 */
export const slugs: Record<string, string> = {
	es: 'aviso-legal',
	en: 'legal-disclaimer',
	ca: 'avis-legal',
	fr: 'mentions-legales',
	it: 'note-legali',
};
export const sitemap = { changefreq: 'yearly', priority: '0.3', lastmod: '2026-09-02' };
